import { useState } from "react";
import { ArrowRight, Chrome } from "lucide-react";
import { useNavigate } from "react-router-dom";

import EmailAuthForm from "../components/EmailAuthForm";

export default function LoginPage() {
  const [mode, setMode] = useState("login");
  const navigate = useNavigate();
  const startGoogleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const completeEmailAuth = (user) => {
    navigate("/dashboard", { replace: true, state: { user } });
  };

  return (
    <main className="auth-page" data-testid="login-page">
      <section className="auth-panel" data-testid="sign-in-panel">
        <a className="brand auth-brand" href="/login" data-testid="login-brand-link">
          <span className="brand-mark" aria-hidden="true">C</span>
          <span>cardfolio</span>
        </a>
        <div className="auth-copy">
          <p className="eyebrow" data-testid="login-overline">Your card business, organized</p>
          <h1 data-testid="login-heading">Start with what matters today.</h1>
          <p data-testid="login-description">
            Sign in to your focused workday, with the right signals already waiting for you.
          </p>
        </div>
        <div className="auth-mode-toggle" data-testid="email-auth-mode-toggle">
          <button
            className={mode === "login" ? "is-active" : ""}
            type="button"
            onClick={() => setMode("login")}
            data-testid="show-email-login-button"
          >
            Sign in
          </button>
          <button
            className={mode === "register" ? "is-active" : ""}
            type="button"
            onClick={() => setMode("register")}
            data-testid="show-email-register-button"
          >
            Create account
          </button>
        </div>
        <EmailAuthForm mode={mode} onSuccess={completeEmailAuth} />
        <div className="auth-divider" data-testid="auth-method-divider">
          <span>or continue with</span>
        </div>
        <button
          className="google-sign-in-button"
          type="button"
          onClick={startGoogleSignIn}
          data-testid="google-sign-in-button"
        >
          <Chrome size={18} strokeWidth={1.8} />
          Google
          <ArrowRight size={17} strokeWidth={1.8} />
        </button>
        <p className="auth-footnote" data-testid="login-footnote">
          Cardfolio is built for the way dealers work.
        </p>
      </section>
      <aside className="auth-aside" data-testid="login-aside">
        <p className="eyebrow">The workday, made clearer</p>
        <p className="auth-quote">“The next best decision should be obvious.”</p>
        <div className="auth-signal">
          <span>Live signal</span>
          <strong>Vintage demand is moving +15%</strong>
        </div>
      </aside>
    </main>
  );
}